import axios from 'axios';
import {isEventSubscribePage} from './eventSubscribe';

const isSubscribePage = () => {
    let isSubscribePage;
    const formPage = document.querySelector('.subscribe__form--page');

    if(formPage){
        // console.log('is newsletter subscribe page!');
        isSubscribePage = true;
    } else {
        // console.log('is NOT newsletter subscribe page!');
        isSubscribePage = false;
    }

    return isSubscribePage;
}

// get all forms
const subscribeForms = Array.from(
    document.querySelectorAll('.subscribe__form')
  );

  if (subscribeForms.length > 0 && (isEventSubscribePage() == false)) {
      const items = Array.from(subscribeForms);
      for (let x = 0; x < items.length; x++) {

        let isSubscribeFormPage = isSubscribePage();

        // get this item
        const item = items[x];
        // get id
        const itemId = item.getAttribute('id');
        // get this form by id
        const currentForm = document.getElementById(itemId);
        // get list id
        const currentFormListId = currentForm.dataset.listId;
        // get this form errors element
        const thisFormErrors = document.querySelector('#'+itemId+' .subscribe__form-fields-error');

        currentForm.addEventListener('submit', event => {
            currentForm.classList.add('subscribe__form--processing');
            event.preventDefault();
            // build request url
            let requestUrl = siteUrl+'/constant-contact-api/';
            // form values
            const thisFormEmailField = document.querySelector('#'+itemId+' .subscribe__form-email');
            // email
            let validEmail = validateEmail(thisFormEmailField.value);
            const subscribeFeedbackSuccessMessage = document.getElementById('subscribe__feedback-success-message');
            const subscribeFeedbackErrorMessage = document.getElementById('subscribe__feedback-error-message');
            if(isSubscribeFormPage == true){
                let header = document.querySelector('#subscribe-page-heading');
                let copy = document.querySelector('#subscribe__content--inner');
                let homeButton = document.querySelector('#subscribe__success');
                // subscribe page only
                let nameError = 'First and last name are required.';
                const thisFormFirstName = document.querySelector('#'+itemId+' .subscribe__form-fname').value;
                const thisFormLastName = document.querySelector('#'+itemId+' .subscribe__form-lname').value;
                let validFirst = validateName(thisFormFirstName);
                let validLast = validateName(thisFormLastName);
                // get address
                const thisFormAddress = document.querySelector('#'+itemId+' .subscribe__form-address').value;
                const thisFormCity = document.querySelector('#'+itemId+' .subscribe__form-city').value;
                const thisFormState = document.querySelector('#'+itemId+' .subscribe__form-state').value;
                const thisFormZip = document.querySelector('#'+itemId+' .subscribe__form-zip').value;
                if (validFirst == 1 && validLast == 1){
                    console.log('first and last name are valid');
                    requestUrl += `?first_name=${thisFormFirstName}`;
                    requestUrl += `&last_name=${thisFormLastName}`;

                    if(validEmail){
                        console.log('submitting subscribe PAGE form');
                        thisFormErrors.innerHTML = '';
                        requestUrl += '&email='+thisFormEmailField.value+( currentFormListId !== '' ? '&list='+currentFormListId : '' );
                        requestUrl += thisFormAddress != '' ? `&address=${encodeURIComponent(thisFormAddress)}` : `` ;
                        requestUrl += thisFormCity != '' ? `&city=${thisFormCity}` : `` ;
                        requestUrl += thisFormState !== 'default' ? `&state=${thisFormState}` : `` ;
                        requestUrl += thisFormZip != '' ? `&zip=${thisFormZip}` : `` ;
                        axios({
                            method:'get',
                            url: requestUrl
                        })
                        .then(function (response) {
                            console.log('success');
                            currentForm.classList.remove('subscribe__form--processing');
                            currentForm.classList.add('subscribe__form--success');
                            if( subscribeFeedbackSuccessMessage && response ){
                                console.log(response);
                                header.classList.add('hide');
                                copy.classList.add('hide');
                                homeButton.classList.add('active');
                                subscribeFeedbackSuccessMessage.innerHTML = response.data.messages;
                            }
                        })
                        .catch(function (error) {
                            console.log('error');
                            currentForm.classList.remove('subscribe__form--processing');
                            currentForm.classList.add('subscribe__form--error');
                            console.log(JSON.stringify(error));
                            if( subscribeFeedbackErrorMessage && error ){
                                console.log(error);
                                header.classList.add('hide');
                                copy.classList.add('hide');
                                subscribeFeedbackErrorMessage.innerHTML = error.data.messages;
                            }
                        });

                    } else {
                        currentForm.classList.remove('subscribe__form--processing');
                        thisFormErrors.innerHTML = currentForm.dataset.emailError;
                    }
                } else {
                    console.log(validFirst);
                    console.log(validLast);
                    currentForm.classList.remove('subscribe__form--processing');
                    console.log('names missing or invalid');
                    thisFormErrors.innerHTML = nameError;
                }
            } else {
                if(validEmail){
                    console.log('submitting FOOTER subscribe form');
                    thisFormErrors.innerHTML = '';
                    requestUrl += '?email='+thisFormEmailField.value+( currentFormListId !== '' ? '&list='+currentFormListId : '' );
                    axios({
                        method:'get',
                        url: requestUrl
                    })
                    .then(function (response) {
                        console.log('success');
                        currentForm.classList.remove('subscribe__form--processing');
                        currentForm.classList.add('subscribe__form--success');
                        if( subscribeFeedbackSuccessMessage && response ){
                            subscribeFeedbackSuccessMessage.innerHTML = response.data.messages;
                        }
                    })
                    .catch(function (error) {
                        console.log('error');
                        currentForm.classList.remove('subscribe__form--processing');
                        currentForm.classList.add('subscribe__form--error');
                        console.log(JSON.stringify(error));
                        if( subscribeFeedbackErrorMessage && error ){
                            subscribeFeedbackErrorMessage.innerHTML = error.data.messages;
                        }
                    });
                } else {
                    currentForm.classList.remove('subscribe__form--processing');
                    thisFormErrors.innerHTML = currentForm.dataset.emailError;
                }
            }
        });
    }
}

// const handleConstantContactAPI = (requestUrl, currentForm) => {

//     let isSubPage = isSubscribePage();
//     const subscribeFeedbackSuccessMessage = document.getElementById('subscribe__feedback-success-message');
//     const subscribeFeedbackErrorMessage = document.getElementById('subscribe__feedback-error-message');

//     axios({
//         method:'get',
//         url: requestUrl
//     })
//     .then(function (response) {
//         currentForm.classList.remove('subscribe__form--processing');
//         currentForm.classList.add('subscribe__form--success');
//         if( subscribeFeedbackSuccessMessage && response ){
//             // if is subscribe page
//             console.log('success');
//             console.log(JSON.stringify(response));
//             if(isSubPage == true){
//                 console.log('success on subscribe page, hiding content');
//                 console.log(response.data.messages);
//                 handleSubscribePageSuccess();
//             }
//             subscribeFeedbackSuccessMessage.innerHTML = response.data.messages;
//         }
//     })
//     .catch(function (error) {
//         currentForm.classList.remove('subscribe__form--processing');
//         currentForm.classList.add('subscribe__form--error');
//         // console.log(JSON.stringify(error));
//         if( subscribeFeedbackErrorMessage && (error != '') ){
//             console.log('fail');
//             console.log(JSON.stringify(error));
//             //console.log(error);
//             subscribeFeedbackErrorMessage.innerHTML = error.data.messages;
//         }
//     });
// }

const validateEmail = email => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

// add validate Name
const validateName = name => {
    console.log('validating name');
    if (!name.replace(/\s/g, "").length) {
        console.log('only spaces');
        return 0;
    } else {
        return 1;
    }
}

const handleSubscribePageSuccess = () => {
    let header = document.querySelector('#subscribe-page-heading');
    let copy = document.querySelector('#subscribe__content--inner');
    header.innerHTML = 'Thank you for subscribing!';
    copy.classList.add('hide');
}

const handleSubscribePageFail = () => {
    let header = document.querySelector('#subscribe-page-heading');
    let copy = document.querySelector('#subscribe__content--inner');
    header.innerHTML = 'Please try again later';
    copy.classList.add('hide');
}


// get constant contact form
/*
const ctctInlineForm = document.getElementById('ctct-inline-form');
if(ctctInlineForm){
    // declare iterval
    let ctctInlineFormInterval;
    // check if form embed has loaded every 500ms
    ctctInlineFormInterval = setInterval(()=>{
        // look for embed
        const ctctFormEmbed = document.querySelector('.ctct-form-embed');
        // if embed found
        if( ctctFormEmbed ){
            // set email placeholder
            const emailField = document.querySelector('input[name="email_address"]');
            emailField ? emailField.setAttribute("placeholder",subscribeData.emailPlaceholder) : null ;
            // set CTA language
            const ctctFormButton = document.querySelector('button.ctct-form-button[type="submit"]');
            ctctFormButton ? ctctFormButton.innerHTML = subscribeData.ctaLanguage : null ;
            // stop checking
            clearInterval(ctctInlineFormInterval);
        }
    },500)
}
*/